export default __webpack_public_path__ + "static/media/error-measure.126936ca.svg";